import { type FC } from "react";
import { formatDate } from "../lib/date_utils";
import { CopyButton } from "./copy_button";
import type { CertificatePolicy } from "../../../shared/models/certificate_policy";

export const PolicyDetailModal: FC<{
  policy: CertificatePolicy;
  onClose: () => void;
}> = ({ policy, onClose }) => {
  const detailRow = (label: string, value: string) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: 16,
        padding: "10px 0",
        borderBottom: "1px solid var(--vmx-gray-100)",
      }}
    >
      <span
        style={{
          fontSize: "0.8125rem",
          color: "var(--vmx-gray-500)",
          fontWeight: 500,
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: "0.8125rem",
          color: "var(--vmx-gray-800)",
          fontWeight: 600,
        }}
      >
        {value}
      </span>
    </div>
  );

  return (
    <div className="vmx-modal" style={{ maxWidth: 480 }}>
      <div className="vmx-modal-header">
        <div className="vmx-modal-title">
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span>{policy.name}</span>
            {policy.isDefault && (
              <span className="vmx-badge vmx-badge-neutral">Default</span>
            )}
          </div>
        </div>
        <button
          className="vmx-btn vmx-btn-ghost vmx-btn-icon"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
      <div className="vmx-modal-body">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            fontFamily: "var(--vmx-font-mono)",
            fontSize: "0.75rem",
            color: "var(--vmx-gray-400)",
            marginBottom: 16,
          }}
        >
          <span>{policy.id}</span>
          <CopyButton text={policy.id} absolute={false} />
        </div>

        {detailRow("Authentication Type", policy.authenticationType)}
        {detailRow("Signature Algorithm", policy.signatureAlgorithm)}
        {detailRow("Key Type", policy.keyType.toUpperCase())}
        {detailRow("Key Length", String(policy.keyLength))}
        {detailRow("Hash Type", policy.hashType.toUpperCase())}
        {detailRow("Duration", `${policy.durationDays} days`)}
        {detailRow("Auto Renew", policy.autoRenew ? "Yes" : "No")}
        {detailRow("Created", formatDate(policy.createdAt))}
      </div>
      <div className="vmx-modal-footer">
        <button className="vmx-btn vmx-btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};
